import { createContext, useContext } from 'react';
import type { PieceId } from './barPlan.ts';

export interface BarPlan {
  hidden: ReadonlySet<PieceId>;
}

export const FULL_PLAN: BarPlan = { hidden: new Set() };
export const BarPlanContext = createContext<BarPlan>(FULL_PLAN);

/** `shows('rain')` is false once the bar has no room for that part. */
export function useShows(): (id: PieceId) => boolean {
  const { hidden } = useContext(BarPlanContext);
  return (id) => !hidden.has(id);
}
